import styled from "styled-components";

export const Container = styled.main`
  max-width: 1000px;
  margin: 0px auto;
  padding: 20px;
`;

export default Container;